// Facilitator portraits. Add an entry here and reference it in people.js to publish a portrait.
export const PORTRAITS = {
  pavana: { src: "/assets/people/pavana.jpg", alt: "Portrait of Pavana" },
  aakanksha: { src: "/assets/people/aakanksha.webp", alt: "Portrait of Aakanksha" },
  adithya: { src: "/assets/people/adithya.jpg", alt: "Portrait of Adithya" },
  anna: { src: "/assets/people/anna.jpg", alt: "Portrait of Anna" },
  ankita: { src: "/assets/people/ankita.jpg", alt: "Portrait of Ankita" },
  "dr-melissa": { src: "/assets/people/dr-melissa.jpg", alt: "Portrait of Dr. Melissa" },
  parineeta: { src: "/assets/people/parineeta.jpg", alt: "Portrait of Parineeta" },
  romy: { src: "/assets/people/romy.jpg", alt: "Portrait of Romy" },
  rucha: { src: "/assets/people/rucha.webp", alt: "Portrait of Rucha" },
  supriya: { src: "/assets/people/supriya.png", alt: "Portrait of Supriya" },
};


// Central asset map. Replace a URL here and it updates everywhere it is used.
const u = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=70`;

export const ASSETS = {
  logo: {
    src: "/assets/wge-logo.webp",
    alt: "Wandering Glider Experiences",
  },
  heroHome: {
    src: u("photo-1470071459604-3b5ec3a7fe05", 2200),
    alt: "Layered green ridges rising above morning mist",
  },
  aboutImage: {
    src: "/assets/dragonfly.jpg",
    alt: "A wandering glider dragonfly resting on green reeds, wings outspread",
  },
  approachImage: {
    src: u("photo-1447752875215-b2761acb3c5d"),
    alt: "Sunlight reaching through a quiet forest",
  },
  peopleField: {
    src: "/assets/people/field-rucha.webp",
    alt: "Rucha with students during an outdoor session",
  },
  bespokeImage: {
    src: u("photo-1501785888041-af3ef285b470"),
    alt: "A still mountain lake beneath evening light",
  },
  goa: {
    src: "/assets/journeys/goa-cover.webp",
    alt: "Palm-lined cliffs above a quiet Goan beach at sunset",
    position: "center 68%",
    tilePosition: "center 45%",
  },
  goaDetail: {
    src: u("photo-1471922694854-ff1b63b20054"),
    alt: "Birds gliding low over a calm sea",
  },
  pench: {
    src: "/assets/journeys/pench-cover.webp",
    alt: "A tiger walking a forest trail above the Pench river valley at dusk",
    position: "center 80%",
    tilePosition: "center 60%",
  },
  approachBanner: {
    src: u("photo-1441974231531-c6227db76b6e"),
    alt: "Sunlight filtering through a tall forest canopy",
  },
  safetyApproach: {
    src: "/assets/safety-approach.webp",
    alt: "A group walking together along a grassy coastal trail",
    position: "center 62%",
  },
  safetyImage: {
    src: "/assets/field-forest.webp",
    alt: "A group walking together along a lush forest trail",
  },
  pondicherry: {
    src: "/assets/pondicherry.jpg",
    alt: "Bright yellow French colonial buildings on a street in Pondicherry's White Town",
  },
  jaipur: {
    src: u("photo-1477587458883-47145ed94245"),
    alt: "The ornate facade of a historic palace in Jaipur",
  },
  hampi: {
    src: "/assets/hampi.jpg",
    alt: "The stone chariot at the Vittala Temple in Hampi",
  },
  ladakh: {
    src: u("photo-1506905925346-21bda4d32df4"),
    alt: "A lone high-altitude peak against a clear sky",
  },
  japan: {
    src: u("photo-1545569341-9eb8b30979d9"),
    alt: "A traditional pagoda among maple trees in Japan",
  },
  southKorea: {
    src: u("photo-1517154421773-0529f29ea451"),
    alt: "A historic palace courtyard in Seoul",
  },
  indonesia: {
    src: u("photo-1537996194471-e657df975ab4"),
    alt: "Lush green terraces on an Indonesian island",
  },
};
